import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CirrusDescriptionComponent } from './cirrus-description.component';
import { CirrusTextModule } from '../text/cirrus-text.module';

@NgModule({
  imports: [CommonModule, CirrusTextModule],
  exports: [CirrusDescriptionComponent],
  declarations: [CirrusDescriptionComponent]
})
export class CirrusDescriptionModule {}
